import { faCalendarAlt, faClockFour, faCommentDots, faNoteSticky, faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import { faPlus, faSearch, faTimes, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'chart.js/auto';
import { getMessaging, isSupported, onMessage } from 'firebase/messaging';
import moment from 'moment';
import React, { Component } from 'react';
import { Alert, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';
import { connect } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { GET, POST } from '../../api';
import concern1Img from '../../assets/images/concern-1.png';
import concern2Img from '../../assets/images/concern-2.png';
import concern3Img from '../../assets/images/concern-3.png';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { sendCloudMessage } from '../../helpers/cloud_message';
import { t } from '../../helpers/translation_helper';
import { firebaseApp } from '../../services/firebase';
import Pagination from '../_partials/Pagination';
var Chance = require('chance');
var chance = new Chance();
const widgetStyle = {
  backgroundColor: '#fff',
  borderRadius: 7,
  padding: '10px 15px',
  height: 200,
  width: '20%',
  marginRight: 14,
  backgroundPosition: 'bottom right',
  backgroundRepeat: 'no-repeat',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  backgroundSize: '60%',
}

const barChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
      position: 'bottom',
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
      },
    },
    y: {
      grid: {
        display: false,
      },
      ticks: {
      },
    },
  },
  elements: {
    bar: {
      borderRadius: 8,
      borderSkipped: false,
    },
  },
};

class ConcernDashboard extends Component {

  messagesEndRef = React.createRef();
  fetchReq = null

  state = {
    concerns: [],
    totalActiveCount: 0,
    needResponseCount: 0,
    urgentCount: 0,
    cnsrn_status: null,
    concernGraphData: {
      labels: [],
      datasets: [
        {
          data: [],
          backgroundColor: [],
        },
      ],
    },
    cdt: {
      fetching: false,
      search: '',
      rows: 10,
      offset: 0,
      order: 'c.cnsrn_id',
      dir: 'DESC',
      lastPage: 0,
      page: 0,
      totalRecords: 0,
      columns: [
        {
          id: 'c.cnsrn_id',
          column: 'cnsrn_id',
          name: 'ID',
          visibility: true,
          sortable: true,
        },
      ],
      data: [],
    },
    modal: {
      show: false,
      data: null,
      notes: [],
      noteText: '',
      discussions: [],
      discussionText: '',
      open: (data) => {
        this.setState({
          modal: {
            ...this.state.modal,
            show: true,
            data,
            notes: [],
            noteText: '',
            discussions: [],
            discussionText: '',
          }
        });

        // if (data.cnsrn_seen !== 'Read') {
        //   this.markConcernAsRead(data.cnsrn_id);
        // }

        this.getNotes(data.cnsrn_id);
        this.getDiscussions(data.cnsrn_id);
      },
      close: () => {
        this.setState({
          modal: {
            ...this.state.modal,
            show: false,
            data: null,
            notes: [],
            noteText: '',
            discussions: [],
            discussionText: '',
          }
        });
      },
    },
    tagModal: {
      show: false,
      data: null,
      getConcernsTagUsersData: [],
      selectedTagUsers: null,
      open: async (data) => {
        const getConcernsTagUsersData = await this.getConcernsTagUsers();
        this.setState({
          tagModal: {
            ...this.state.tagModal,
            show: true,
            data,
            getConcernsTagUsersData
          }
        });
      },
      close: () => {
        this.setState({
          tagModal: {
            ...this.state.tagModal,
            show: false,
            data: null,
            getConcernsTagUsersData: [],
            selectedTagUsers: null,
          }
        });
      },
    }
  };

  componentDidMount() {

    const { search, rows: limit, order, dir } = this.state.cdt;
    this.fetch({
      search,
      limit,
      order,
      dir,
      page: 0,
    });

    this.getData();
    this.subscribeToMessage()
    // On Browser Tab Focus
    // document.addEventListener('visibilitychange', () => {
    //   if (document.visibilityState == 'visible') {
    //     const { currentChat } = this.state;
    //     if (currentChat !== null) {
    //       this.getNewDiscussion();
    //     } else {
    //       this.getChatsCount();
    //     }
    //   }
    // });
  }

  subscribeToMessage = async () => {
    let isBrowserSupported = await isSupported()
    if (isBrowserSupported) {
      const messaging = getMessaging(firebaseApp);
      onMessage(messaging, (payload) => {
        const { modal } = this.state;
        if (modal.show && modal.data.cnsrn_id == payload.data.cnsrn_id && payload.data.actionType == 'NewConcernsDiscussion') {
          this.getNewDiscussion();
        } else if (modal.show && modal.data.cnsrn_id == payload.data.cnsrn_id && payload.data.actionType == 'DeleteConcernsDiscussion') {
          // this.triggerDeleteChatDetails(payload.data.cnsrn_id, payload.data.cnsrn_d_id);
        } else {
          this.fetch({
            search: this.state.cdt.search,
            limit: this.state.cdt.rows,
            order: this.state.cdt.order,
            dir: this.state.cdt.dir,
            page: 0,
          });
          toast.info(payload.data.title);
        }
      });
    }
  }

  getNewDiscussion = async () => {
    let { modal } = this.state;
    if (this.getNewDiscussionReq) {
      this.getNewDiscussionReq.abort();
    }
    this.getNewDiscussionReq = new AbortController();
    try {
      const res = await GET('concern-dashboard/get-new-discussion', {
        params: {
          cnsrn_id: modal.data.cnsrn_id,
          cnsrn_d_id: modal.discussions[modal.discussions.length - 1].cnsrn_d_id,
        },
        signal: this.getNewDiscussionReq.signal,
      });
      if (res) {
        // WHEN NEW MESSAGE IS RECEIVED ALL OLD MESSAGES WILL BE CHANGED TO READ
        let resData = res.data
        this.setState(
          {
            modal: { ...modal, discussions: resData.data.concerns_discussion.concat(modal.discussions) }
          });
        //! SCROLL TO BOTTOM HERE
      }
    } catch (err) {
      // toast.error(t('Something went wrong while fetching chat!'));
    }
  }

  getData = async () => {
    try {
      const res = await GET('concern-dashboard/get-widget-data');

      if (res.status === 200) {
        const data = res.data;

        let concernGraphData = {
          labels: data.monthly_counts.map(item => item.month),
          datasets: [
            {
              data: data.monthly_counts.map(item => item.Open),
              backgroundColor: ['#007bff',],
            },
            {
              data: data.monthly_counts.map(item => item.Closed),
              backgroundColor: ['#6c757d'],
            },
            {
              data: data.monthly_counts.map(item => item.Resolved),
              backgroundColor: ['#28a745'],
            },
          ],
        };


        this.setState({
          totalActiveCount: data.total_active_count,
          needResponseCount: data.need_response_count,
          urgentCount: data.urgent_count,
          concernGraphData
        });
      } else {
        console.error('Failed to fetch concern data:', res);
      }

    } catch (err) {
      console.error('Error fetching concern data:', err);
    }
  }

  getConcernsTagUsers = async () => {
    try {
      const res = await GET('concern-dashboard/get-concerns-tag-users', {
        params: {
        }
      });
      if (res.status === 200) {
        return res.data;
      } else {
        console.error('Failed to fetch getConcernsTagUsersData:', res);
        return [];
      }
    } catch (err) {
      console.error('Error fetching getConcernsTagUsersData:', err);
      return [];
    }
  }


  fetch = async (params) => {
    this.setState({
      cdt: {
        ...this.state.cdt,
        fetching: true,
      },
    });

    if (this.fetchReq) {
      this.fetchReq.abort();
    }

    this.fetchReq = new AbortController();

    try {

      const requestParams = {
        search: params.search,
        order: params.order,
        dir: params.dir,
        limit: params.limit,
        offset: parseInt(params.page) * parseInt(params.limit),
      };

      if (this.state.cnsrn_priority) {
        requestParams.cnsrn_priority = this.state.cnsrn_priority.value;
      }

      if (this.state.cnsrn_status) {
        requestParams.cnsrn_status = this.state.cnsrn_status.value;
      }

      const res = await GET('concern-dashboard/get', {
        signal: this.fetchReq.signal,
        params: requestParams,
      });

      if (res.status === 200) {
        this.setState({
          cdt: {
            ...this.state.cdt,
            fetching: false,
            search: params.search,
            rows: parseInt(params.limit),
            offset: parseInt(params.page) * parseInt(params.limit),
            order: params.order,
            dir: params.dir,
            page: params.page,
            totalRecords: parseInt(res.data.total_count_filtered),
            lastPage: Math.ceil(
              parseInt(res.data.total_count_filtered) / parseInt(params.limit)
            ),
            data: res.data.data.map((item) => {
              return {
                uid: chance.guid(),
                collapse: true,
                ...item,
              };
            }),
          },
        });
      }
    } catch (err) {
      console.log('err', err);
      this.setState({
        cdt: {
          ...this.state.cdt,
          fetching: false,
        },
      });
    }
  };

  handleCloseConcern = async (cnsrn_status) => {
    const data = this.state.modal.data;
    const fData = new FormData();
    fData.append('cnsrn_id', data.cnsrn_id);
    fData.append('cnsrn_final_comment', data.cnsrn_final_comment);
    fData.append('cnsrn_status', cnsrn_status);

    try {
      const res = await POST('concern-dashboard/close-concern', fData);

      if (res.status === 200) {
        toast.success(t('Concern closed successfully.'));
        this.state.modal.close();
        this.fetch({
          search: this.state.cdt.search,
          limit: this.state.cdt.rows,
          order: this.state.cdt.order,
          dir: this.state.cdt.dir,
          page: 0,
        });
        this.getData();
      } else {
        toast.error(t('Failed to close concern.'));
      }
    } catch (err) {
      console.error('Error closing concern:', err);
      toast.error(t('An error occurred while closing the concern.'));
      return;
    }

  }

  // markConcernAsRead = async (cnsrn_id) => {
  //   const fData = new FormData();
  //   fData.append('cnsrn_id', cnsrn_id);

  //   try {
  //     const res = await POST('concern-dashboard/mark-as-read', fData);

  //     if (res.status === 200) {
  //       this.setState({
  //         cdt: {
  //           ...this.state.cdt,
  //           data: this.state.cdt.data.map(item =>
  //             item.cnsrn_id === cnsrn_id
  //               ? { ...item, cnsrn_seen: 'Read' }
  //               : item
  //           )
  //         },
  //         modal: {
  //           ...this.state.modal,
  //           data: {
  //             ...this.state.modal.data,
  //             cnsrn_seen: 'Read'
  //           }
  //         }
  //       });
  //     } else {
  //       console.error('Failed to mark concern as read:', res);
  //     }
  //   } catch (err) {
  //     console.error('Error marking concern as read:', err);
  //   }
  // };

  addTag = async () => {
    if (!this.state.tagModal.selectedTagUsers) {
      toast.error(t('Please select a User to tag.'));
      return;
    }
    const data = this.state.tagModal.data;
    const selectedTagUsers = this.state.tagModal.selectedTagUsers;
    const fData = new FormData();
    fData.append('cnsrn_id', data.cnsrn_id);
    fData.append('user_id', selectedTagUsers.user_id);

    try {
      const res = await POST('concern-dashboard/add-tag', fData);

      if (res.status === 200) {
        toast.success(t('Tag added successfully.'));
        this.state.tagModal.close();
        this.setState({
          modal: {
            ...this.state.modal,
            data: {
              ...this.state.modal.data,
              users_tags: [
                ...(this.state.modal.data.users_tags || []),
                {
                  user_id: selectedTagUsers.user_id,
                  full_name: selectedTagUsers.full_name,
                },
              ],
            },
          },
        });
        this.fetch({
          search: this.state.cdt.search,
          limit: this.state.cdt.rows,
          order: this.state.cdt.order,
          dir: this.state.cdt.dir,
          page: 0,
        });
      } else {
        toast.error(t('Failed to add tag.'));
      }
    } catch (err) {
      console.error('Error adding tag:', err);
      toast.error(t('An error occurred while adding the tag.'));
    }
  }

  removeTag = async (userId) => {
    const data = this.state.modal.data;
    const fData = new FormData();
    fData.append('cnsrn_id', data.cnsrn_id);
    fData.append('user_id', userId);

    try {
      const res = await POST('concern-dashboard/remove-tag', fData);

      if (res.status === 200) {
        toast.success(t('Tag removed successfully.'));

        this.setState({
          modal: {
            ...this.state.modal,
            data: {
              ...this.state.modal.data,
              users_tags: this.state.modal.data.users_tags.filter(tag => tag.user_id !== userId),
            },
          },
        });

        this.fetch({
          search: this.state.cdt.search,
          limit: this.state.cdt.rows,
          order: this.state.cdt.order,
          dir: this.state.cdt.dir,
          page: this.state.cdt.page,
        });
      } else {
        toast.error(t('Failed to remove tag.'));
      }
    } catch (err) {
      console.error('Error removing tag:', err);
      toast.error(t('An error occurred while removing the tag.'));
    }
  }

  getNotes = async (cnsrn_id) => {
    try {
      const res = await GET('concern-dashboard/get-notes', {
        params: {
          cnsrn_id: cnsrn_id,
        }
      });

      if (res.status === 200) {
        this.setState({
          modal: {
            ...this.state.modal,
            notes: res.data || []
          }
        });
      } else {
        console.error('Failed to fetch notes:', res);
      }
    } catch (err) {
      console.error('Error fetching notes:', err);
    }
  };

  addNote = async () => {
    if (!this.state.modal.noteText.trim()) {
      toast.error(t('Please enter a note text.'));
      return;
    }

    const data = this.state.modal.data;
    const fData = new FormData();
    fData.append('cnsrn_id', data.cnsrn_id);
    fData.append('c_note_text', this.state.modal.noteText.trim());

    try {
      const res = await POST('concern-dashboard/add-note', fData);

      if (res.status === 200) {
        toast.success(t('Note added successfully.'));

        this.setState({
          modal: {
            ...this.state.modal,
            noteText: ''
          }
        });

        this.getNotes(data.cnsrn_id);
      } else {
        toast.error(t('Failed to add note.'));
      }
    } catch (err) {
      console.error('Error adding note:', err);
      toast.error(t('An error occurred while adding the note.'));
    }
  };

  //! NEED TO IMPLEMENT PAGINATION HERE, NEED TO GET NEW MESSAGE WHEN NOTIFICATION RECEIVED LIKE CHAT
  getDiscussions = async (cnsrn_id) => {
    try {
      const res = await GET('concern-dashboard/get-discussions', {
        params: {
          cnsrn_id: cnsrn_id,
        }
      });

      if (res.status === 200) {
        this.setState({
          modal: {
            ...this.state.modal,
            discussions: res.data || []
          }
        }, () => {
          this.scrollToBottom();
        });
      } else {
        console.error('Failed to fetch discussions:', res);
      }
    } catch (err) {
      console.error('Error fetching discussions:', err);
    }
  };

  //! IMPLEMENT ADD ATTACHMENT HERE
  addMsg = async () => {
    if (!this.state.modal.discussionText.trim()) {
      toast.error(t('Please enter a message.'));
      return;
    }

    const full_name = this.props.authData.loginData.full_name;

    const data = this.state.modal.data;
    const fData = new FormData();
    fData.append('cnsrn_id', data.cnsrn_id);
    fData.append('cnsrn_d_message', this.state.modal.discussionText.trim());

    try {
      const res = await POST('concern-dashboard/add-msg', fData);

      if (res.status === 200) {
        // toast.success(t('Message sent successfully.'));

        //  Send FCM
        sendCloudMessage(
          data.created_by,
          `New message from ${full_name}`,
          this.state.modal.discussionText.trim(),
          { cnsrn_id: data.cnsrn_id, actionType: 'NewConcernsDiscussion' }
        );

        this.setState({
          modal: {
            ...this.state.modal,
            discussionText: ''
          }
        });

        this.getDiscussions(data.cnsrn_id);
      } else {
        toast.error(t('Failed to send message.'));
      }
    } catch (err) {
      console.error('Error sending message:', err);
      toast.error(t('An error occurred while sending the message.'));
    }
  };

  scrollToBottom = () => {
    if (this.messagesEndRef.current) {
      // this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
      this.messagesEndRef.current.scrollIntoView();
    }
  };

  render() {
    const { lang_orientation: dir } = this.props.defaultLanguage;

    // console.log('%cSTATES', 'font-size: 20px; font-weight: bold; color: orange;', this.state);
    // console.log('%cPROPS', 'font-size: 20px; font-weight: bold; color: pink;', this.props);

    return (
      <div className='grey-section mb-0' style={{ marginLeft: 12, borderRadius: 14, padding: 14, height: 'calc(100vh - 135px)', overflowY: 'auto' }}>
        <div style={{ display: 'flex', marginBottom: 14, }}>
          <div style={{
            ...widgetStyle,
            backgroundImage: `url(${concern1Img})`,
          }}>
            <strong>{t('Total Active')}</strong>
            <div style={{ fontSize: 80, color: '#934DFF', lineHeight: '80px' }}>
              {this.state.totalActiveCount}
            </div>
          </div>
          <div style={{
            ...widgetStyle,
            backgroundImage: `url(${concern2Img})`,
          }}>
            <strong>{t('Need Response')}</strong>
            <div style={{ fontSize: 80, color: '#83868D', lineHeight: '80px' }}>
              {this.state.needResponseCount}
            </div>
          </div>
          <div style={{
            ...widgetStyle,
            backgroundImage: `url(${concern3Img})`,
          }}>
            <strong>{t('Urgent')}</strong>
            <div style={{ fontSize: 80, color: '#A80000', lineHeight: '80px' }}>
              {this.state.urgentCount}
            </div>
          </div>
          <div style={{
            ...widgetStyle,
            marginRight: 0,
            width: '40%',
          }}>
            <Bar
              options={barChartOptions}
              data={this.state.concernGraphData}
              height={305}
            />
          </div>
        </div>
        <div
          style={{
            background: '#fff',
            borderRadius: 7,
            alignItems: 'center',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            position: 'relative',
            minHeight: 'calc(100vh - 377px)',
          }}>
          <div className='p-2'>
            <Row>
              <Col className='d-flex align-items-center ps-3'><strong>{t('Concerns')}</strong></Col>
              <Col>
                <div className='cdt-search' style={{ height: 38, width: '100%' }}>
                  <input
                    style={{
                      paddingLeft: 17
                    }}
                    type='text'
                    ref={this.searchFieldRef}
                    defaultValue={this.state.cdt.search}
                    onChange={(e) =>
                      this.fetch({
                        search: e.target.value,
                        limit: this.state.cdt.rows,
                        order: this.state.cdt.order,
                        dir: this.state.cdt.dir,
                        page: 0,
                      })
                    }
                    placeholder={t('Search...')}
                  />
                  <button
                    onClick={() => {
                      this.fetch({
                        search: '',
                        limit: this.state.cdt.rows,
                        order: this.state.cdt.order,
                        dir: this.state.cdt.dir,
                        page: 0,
                      });
                      this.searchFieldRef.current.value = '';
                    }}>
                    <FontAwesomeIcon
                      icon={this.state.cdt.search == '' ? faSearch : faXmark}
                      color={
                        brand_colors[this.props.defaultTheme.theme_id].color18
                      }
                    />
                  </button>
                </div>
              </Col>
              <Col className='ps-0'>
                <Select
                  isClearable
                  placeholder={t('Select Priority')}
                  options={[
                    { value: 'Low', label: 'Low' },
                    { value: 'Normal', label: 'Normal' },
                    { value: 'High', label: 'Urgent' }
                  ]}
                  onChange={(obj) => this.setState({
                    cnsrn_priority: obj,
                  }, () => this.fetch({
                    search: '',
                    limit: this.state.cdt.rows,
                    order: this.state.cdt.order,
                    dir: this.state.cdt.dir,
                    page: 0,
                  }))}
                  value={this.state.cnsrn_priority}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999999999999
                    }),
                  }}
                  formatOptionLabel={option => (
                    <span style={{
                      fontSize: 12,
                      color: '#fff',
                      backgroundColor:
                        option.label === 'Urgent' ? '#D13341' :
                          option.label === 'Normal' ? '#46CBF3' :
                            option.label === 'Low' ? '#F9BF00' : '#f2f2f2',
                      padding: '4px 8px',
                      borderRadius: 4,
                      fontWeight: 'bold',
                    }}>
                      {option.label === 'High' ? 'URGENT' : option.label?.toUpperCase() || 'NORMAL'}
                    </span>
                  )}
                />
              </Col>
              <Col className='ps-0'>
                <Select
                  isClearable
                  placeholder={t('Select Status')}
                  options={[
                    { value: 'Open', label: 'Open' },
                    { value: 'Closed', label: 'Closed' },
                    { value: 'Resolved', label: 'Resolved' }
                  ]}
                  onChange={(obj) => this.setState({
                    cnsrn_status: obj,
                  }, () => this.fetch({
                    search: '',
                    limit: this.state.cdt.rows,
                    order: this.state.cdt.order,
                    dir: this.state.cdt.dir,
                    page: 0,
                  }))}
                  value={this.state.cnsrn_status}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999999999999
                    }),
                  }}
                  formatOptionLabel={option => (
                    <span style={{
                      fontSize: 12,
                      color: '#fff',
                      backgroundColor:
                        option.label === 'Open' ? '#007bff' :
                          option.label === 'Closed' ? '#6c757d' :
                            option.label === 'Resolved' ? '#28a745' : '#6c757d',
                      padding: '3px 8px',
                      borderRadius: 4,
                      fontWeight: 'bold',
                      textTransform: 'uppercase'
                    }}>
                      {option.label || 'OPEN'}
                    </span>
                  )}
                />
              </Col>
            </Row>
          </div>
          <div style={{ borderTop: '#f2f2f2 1px solid', height: 'calc(100vh - 495px)', overflowY: 'auto', borderBottom: '1px solid #f2f2f2', }}>
            {this.state.cdt.fetching &&
              <div
                style={{ flex: 1 }}
                className='d-flex flex-column align-items-center justify-content-center'>
                <Spinner as='span' animation='grow' size='sm' />{' '}
                {t('Loading Data')}
              </div>
            }
            {!this.state.cdt.fetching && this.state.cdt.data.length === 0 &&
              <div
                style={{ flex: 1 }}
                className='d-flex flex-column align-items-center justify-content-center'>
                {t('No Data Found')}
              </div>
            }
            {(!this.state.cdt.fetching && this.state.cdt.data.length !== 0) &&
              this.state.cdt.data.map((item, index) =>
                <div key={index}
                  onClick={() => this.state.modal.open(item)}
                  className='row-hoverable' style={{
                    padding: 10,
                    borderBottom: index === this.state.cdt.data.length - 1 ? 'none' : '1px solid #f2f2f2',
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <div style={{
                    width: '7%',
                  }}>
                    <span style={{
                      fontSize: 12,
                      color: '#fff',
                      backgroundColor:
                        item.cnsrn_priority === 'High' ? '#D13341' :
                          item.cnsrn_priority === 'Normal' ? '#46CBF3' :
                            item.cnsrn_priority === 'Low' ? '#F9BF00' : '#f2f2f2',
                      padding: '4px 8px',
                      borderRadius: 4,
                      fontWeight: 'bold',
                    }}>
                      {item.cnsrn_priority === 'High' ? 'URGENT' : item.cnsrn_priority?.toUpperCase() || 'NORMAL'}
                    </span>
                  </div>
                  <div style={{ width: '31%', paddingRight: 20, boxSizing: 'border-box' }}>
                    <div style={{
                      fontSize: 14,
                      fontWeight: item.cnsrn_seen === 'Unread' ? 'bold' : 'normal',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}>
                      {item.cnsrn_title}
                    </div>
                  </div>
                  <div style={{ width: '15%', paddingRight: 20, boxSizing: 'border-box' }}>{item.parent_name}</div>
                  <div style={{ width: '9%' }}>
                    <span style={{
                      fontSize: 12,
                      color: '#fff',
                      backgroundColor:
                        item.cnsrn_status === 'Open' ? '#007bff' :
                          item.cnsrn_status === 'Closed' ? '#6c757d' :
                            item.cnsrn_status === 'Resolved' ? '#28a745' : '#6c757d',
                      padding: '4px 8px',
                      borderRadius: 4,
                      fontWeight: 'bold',
                      textTransform: 'uppercase'
                    }}>
                      {item.cnsrn_status || 'OPEN'}
                    </span>
                  </div>
                  <div style={{ width: '16%', paddingRight: 20, boxSizing: 'border-box' }}>
                    {moment(item.created_on).format('MMM DD, YYYY - h:mm A')}
                  </div>
                  <div style={{ width: '15%' }}>{item.cnsrntype_name}</div>
                  <div className='d-flex align-items-center justify-content-end' style={{ width: '7%' }}>
                    {item.new_concern_discussion_count > 0 &&
                      <span style={{
                        width: 25,
                        height: 25,
                        borderRadius: '50%',
                        backgroundColor: '#F9BF00',
                        color: '#000',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 14,
                        fontWeight: 'bold',
                      }}>{item.new_concern_discussion_count}</span>
                    }
                    <FontAwesomeIcon icon={faCommentDots} style={{ fontSize: 25, marginLeft: 10 }} />
                  </div>
                </div>
              )
            }
          </div>
          <div className='px-3' style={{ paddingTop: 13, }}>
            <Pagination
              pageCount={this.state.cdt.lastPage || 1}
              forcePage={this.state.cdt.page}
              callbackParams={{
                search: this.state.cdt.search,
                limit: this.state.cdt.rows,
                order: this.state.cdt.order,
                dir: this.state.cdt.dir,
              }}
              callback={this.fetch}
            />
          </div>
        </div>

        {/* Concern Modal */}
        <Modal show={this.state.modal.show} onHide={() => this.state.modal.close()} fullscreen>
          <Modal.Header closeButton>
            <Row>
              <Col md={'auto'}><strong>{this.state.modal.data?.cnsrn_title} </strong></Col>
              <Col md={'auto'} className='p-0' style={{ color: '#D9D9D9' }}>•</Col>
              <Col md={'auto'}>{this.state.modal.data?.cnsrntype_name}</Col>
              <Col>
                <span style={{
                  fontSize: 12,
                  color: '#fff',
                  backgroundColor:
                    this.state.modal.data?.cnsrn_priority === 'High' ? '#D13341' :
                      this.state.modal.data?.cnsrn_priority === 'Normal' ? '#46CBF3' :
                        this.state.modal.data?.cnsrn_priority === 'Low' ? '#F9BF00' : '#f2f2f2',
                  padding: '2px 6px',
                  borderRadius: 4,
                  fontWeight: 'bold',
                }}>
                  {this.state.modal.data?.cnsrn_priority === 'High' ? 'URGENT' : this.state.modal.data?.cnsrn_priority?.toUpperCase() || 'NORMAL'}
                </span>
              </Col>
            </Row>
          </Modal.Header>
          <Modal.Body className='p-0 overflow-hidden'>
            <Row>
              {/* Left Section */}
              <Col md={3} className='d-flex flex-column' style={{
                padding: '20px 20px 20px 30px',
                height: 'calc(100vh - 58px)',
                overflowY: 'auto',
              }}>
                <div className='mb-4'>
                  <strong className='d-block mb-2'>{t('Description')}</strong>
                  {this.state.modal.data?.cnsrn_desc || t('No description provided.')}
                </div>
                <div className='mb-4'>
                  <strong className='d-block mb-2'>{t('Student')}</strong>
                  <strong style={{
                    color: '#fff',
                    backgroundColor: '#40A121',
                    padding: '2px 8px 3px 8px',
                    borderRadius: 5,
                    marginRight: 10,
                    fontSize: 14,
                  }}>{this.state.modal.data?.class_theme}</strong>
                  {this.state.modal.data?.child_name}
                </div>
                <div className='mb-4'>
                  <strong className='d-block mb-2'>{t('Parent')}</strong>
                  <span className='d-block mb-1'>{this.state.modal.data?.parent_name}</span>
                  <span style={{
                    color: '#fff',
                    backgroundColor: '#46CBF3',
                    padding: '2px 8px 3px 8px',
                    borderRadius: 5,
                    marginRight: 10,
                    fontSize: 14,
                  }}>{this.state.modal.data?.phone1}</span>
                  <span style={{
                    color: '#fff',
                    backgroundColor: '#46CBF3',
                    padding: '2px 8px 3px 8px',
                    borderRadius: 5,
                    marginRight: 10,
                    fontSize: 14,
                  }}>{this.state.modal.data?.email1}</span>
                </div>
                <div className='mb-4'>
                  <strong className='d-block mb-2'>{t('Created')}</strong>
                  <span style={{
                    color: '#000',
                    backgroundColor: '#E7E8E9',
                    padding: '2px 8px 3px 8px',
                    borderRadius: 5,
                    marginRight: 10,
                    fontSize: 14,
                  }}><FontAwesomeIcon icon={faCalendarAlt} style={{ marginRight: 10 }} />
                    {this.state.modal.data && moment(this.state.modal.data.created_on).format('MMM DD, YYYY - h:mm A')}</span>
                </div>
                <div className='mb-4'>
                  <strong className='d-block mb-2'>{t('Tagged')}</strong>
                  {this.state.modal.data?.users_tags && this.state.modal.data.users_tags.length > 0 && (
                    this.state.modal.data.users_tags.map((user, index) => (
                      <span
                        key={index}
                        style={{
                          color: '#000',
                          backgroundColor: '#E7E8E9',
                          paddingLeft: 8,
                          paddingRight: ![3, 4].includes(this.props.authData.loginData.role_id) ? 0 : 14,
                          borderRadius: 5,
                          marginRight: 10,
                          marginBottom: 10,
                          fontSize: 14,
                          display: 'inline-flex',
                          alignItems: 'center',
                          height: 30,
                        }}
                      >
                        @ {user.full_name}
                        {![3, 4].includes(this.props.authData.loginData.role_id) &&
                          <Button
                            onClick={(e) => {
                              this.removeTag(user.user_id);
                            }}
                            style={{
                              borderTopLeftRadius: 0,
                              borderBottomLeftRadius: 0,
                            }} className='ms-2' size="sm" variant='danger'>
                            <FontAwesomeIcon
                              style={{
                                lineHeight: '25px'
                              }}
                              icon={faTimes} />
                          </Button>
                        }
                      </span>
                    ))
                  )}
                  {![3, 4].includes(this.props.authData.loginData.role_id) &&
                    <Button
                      size='sm'
                      variant='light'
                      disabled={this.state.modal.data?.cnsrn_status === 'Closed' || this.state.modal.data?.cnsrn_status === 'Resolved'}
                      onClick={() => this.state.tagModal.open(this.state.modal.data)}
                      style={{
                        marginTop: -3,
                        color: '#000',
                        backgroundColor: '#E7E8E9',
                        cursor: (this.state.modal.data?.cnsrn_status === 'Closed' || this.state.modal.data?.cnsrn_status === 'Resolved') ? 'default' : 'pointer',
                        opacity: (this.state.modal.data?.cnsrn_status === 'Closed' || this.state.modal.data?.cnsrn_status === 'Resolved') ? 0.5 : 1,
                      }}><FontAwesomeIcon icon={faPlus} /></Button>
                  }
                </div>
                <div className='mb-4' style={{ flex: 1 }}>
                  <strong className='d-block mb-2'>{t('Final Comment')}</strong>
                  <Form.Group className="mb-3">
                    <Form.Control
                      disabled={this.state.modal.data?.cnsrn_status === 'Closed' || this.state.modal.data?.cnsrn_status === 'Resolved'}
                      onChange={(e) => {
                        this.setState({
                          modal: {
                            ...this.state.modal,
                            data: {
                              ...this.state.modal.data,
                              cnsrn_final_comment: e.target.value
                            }
                          }
                        });
                      }}
                      value={this.state.modal.data?.cnsrn_final_comment || ''}
                      as="textarea" rows={3} />
                  </Form.Group>
                </div>
                <Row>
                  <Col className='pe-2'>
                    <Button
                      size='sm'
                      className='w-100'
                      onClick={() => this.handleCloseConcern('Closed')}
                      disabled={this.state.modal.data?.cnsrn_status === 'Closed' || this.state.modal.data?.cnsrn_status === 'Resolved'} variant="danger"> {t('Close')}</Button>
                  </Col>
                  <Col className='ps-2'>
                    <Button
                      size='sm'
                      className='w-100'
                      onClick={() => this.handleCloseConcern('Resolved')}
                      disabled={this.state.modal.data?.cnsrn_status === 'Closed' || this.state.modal.data?.cnsrn_status === 'Resolved'} variant="success"> {t('Resolved & Close')}</Button>
                  </Col>
                </Row>
              </Col>

              {/* Middle Section */}
              <Col md={6} className='d-flex flex-column pe-0' style={{
                background: '#EAEAEA',
                height: 'calc(100vh - 58px)',
                overflowY: 'auto',
              }}>
                <div style={{
                  height: 'calc(100vh - 111px)',
                  overflowY: 'auto',
                  padding: '10px 20px 20px 10px',
                }}>
                  {this.state.modal.discussions.length === 0 ? (
                    <div className='text-center text-muted' style={{ padding: '20px 0' }}>
                      {t('No messages yet')}
                    </div>
                  ) : (
                    <>
                      {this.state.modal.discussions
                        .sort((a, b) => new Date(a.created_on) - new Date(b.created_on))
                        .map((discussion, index) => (
                          <div key={index} className={`concern-msg ${discussion.created_by == this.props.authData.loginData.user_id ? 'outgoing' : 'incoming'}`}>
                            <div className='msg-header'>
                              <span className='msg-author'>{discussion.full_name}</span>
                            </div>
                            <div className='msg-content'>
                              {discussion.cnsrn_d_message}
                            </div>
                            <div className='msg-footer'>
                              <span className='msg-date'>
                                <FontAwesomeIcon icon={faClockFour} className='me-1' />
                                {moment(discussion.created_on).format('MMM DD, YYYY - h:mm A')}
                              </span>
                            </div>
                          </div>
                        ))}
                      <div ref={this.messagesEndRef} />
                    </>
                  )}
                </div>
                <div className='d-flex align-items-center' style={{ width: '100%', paddingLeft: 10, paddingRight: 20 }}>
                  <div style={{ flex: 1 }} className='me-2'>
                    <Form.Control
                      style={{ fontSize: 14, height: 35 }}
                      type="text"
                      placeholder={t('Type your message here...')}
                      value={this.state.modal.discussionText}
                      onChange={(e) => {
                        this.setState({
                          modal: {
                            ...this.state.modal,
                            discussionText: e.target.value
                          }
                        });
                      }}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          this.addMsg();
                        }
                      }}
                    />
                  </div>
                  <Button
                    style={{ height: 35 }}
                    size='sm'
                    variant='info'
                    onClick={this.addMsg}
                    disabled={!this.state.modal.discussionText.trim()}
                  >
                    <FontAwesomeIcon icon={faPaperPlane} className='me-1' />
                  </Button>
                </div>
              </Col>

              {/* Right Section */}
              <Col md={3} className='d-flex flex-column' style={{
                padding: '15px 30px 20px 20px',
                height: 'calc(100vh - 58px)',
                overflowY: 'auto',
              }}>
                <div>
                  <h5>{t('Internal Staff Notes')}</h5>
                  <Alert style={{ fontSize: 12 }} className='p-2 px-3' variant={'warning'}><strong>Note:</strong> Internal notes are only visible to staff and are not shared with parents.</Alert>
                </div>
                <div style={{ height: 'calc(100vh - 243px)', overflowY: 'auto', marginBottom: 15 }}>
                  {this.state.modal.notes.length === 0 ? (
                    <div className='text-center text-muted' style={{ padding: '20px 0' }}>
                      {t('No notes available')}
                    </div>
                  ) : (
                    this.state.modal.notes.map((note, index) => (
                      <div key={index} className={`concern-note ${index === this.state.modal.notes.length - 1 ? 'mb-0' : ''}`}>
                        <div className='note-header'>
                          <span className='note-author'>{note.full_name}</span>
                          <span className='note-date'>
                            <FontAwesomeIcon icon={faClockFour} className='me-1' />
                            {moment(note.created_on).format('MMM DD, YYYY - h:mm A')}
                          </span>
                        </div>
                        <div className='note-content'>
                          {note.c_note_text}
                        </div>
                      </div>
                    ))
                  )}
                </div>
                <div className='d-flex align-items-center' style={{ width: '100%' }}>
                  <div style={{ flex: 1 }} className='me-2'>
                    <Form.Control
                      style={{ fontSize: 14, height: 35 }}
                      type="text"
                      placeholder={t('Add internal note for the staff')}
                      value={this.state.modal.noteText}
                      onChange={(e) => {
                        this.setState({
                          modal: {
                            ...this.state.modal,
                            noteText: e.target.value
                          }
                        });
                      }}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          this.addNote();
                        }
                      }}
                    />
                  </div>
                  <Button
                    style={{ height: 35 }}
                    size='sm'
                    variant='warning'
                    onClick={this.addNote}
                    disabled={!this.state.modal.noteText.trim()}
                  >
                    <FontAwesomeIcon icon={faNoteSticky} className='me-1' />
                    {t('Add Note')}
                  </Button>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        {/* Tagging Modal */}
        <Modal backdropClassName="tag-modal-backdrop"
          centered show={this.state.tagModal.show} onHide={this.state.tagModal.close}>
          <Modal.Header closeButton>
            <Modal.Title>{t('Tag')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Select
              options={this.state.tagModal.getConcernsTagUsersData
                .filter(item => {
                  return !this.state.modal.data?.users_tags.find((user) => user.user_id == item.user_id);
                })
                .map(item => {
                  return {
                    ...item,
                    value: item.user_id,
                    label: item.full_name,
                  }
                })}
              onChange={(obj) => {
                this.setState({
                  tagModal: {
                    ...this.state.tagModal,
                    selectedTagUsers: obj
                  }
                });
              }}
              value={this.state.tagModal.selectedTagUsers}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 99999999999999
                }),
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.state.tagModal.close}>
              Close
            </Button>
            <Button variant="primary" onClick={this.addTag}>
              Add
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(ConcernDashboard);
